function bindAndHandleMealCategory(selector) {
    const $this = $(selector);

    if (0 === $this.length || $this.prop('disabled')) {
        return;
    }

    $this.on('change', function (e) { handleMealCategory($(e.currentTarget))});
    handleMealCategory($this);
}

function handleMealCategory($this) {
    const $goals = $('select[name=ntr_goal]');
    const $vege = $('select[name=vege]');
    const $mpd = $('select[name=mpd]');
    const $daysPerMealplan = $('select[name=days_per_mealplan]');
    const mpdSelected = $mpd.data('selected');
    const goalSelected = $goals.data('selected');
    const vegeSelected = $vege.data('selected');
    const daysPerMealplanSelected = $vege.data('selected');
    const $preferredRecipes = $('#preferred_recipes');
    const recipesSelected   = $preferredRecipes.data('selected') || [];

    jQuery.getJSON($this.find('option:checked').data('url'), {}, function (response) {
        $goals.find('option').remove();
        $goals.append($("<option />").val('').text(''));

        response.goals.forEach(function (goal) {
            const option = $("<option />").val(goal.id).text(goal.name);

            if (goalSelected === goal.id) {
                option.attr('selected', true);
            }

            $goals.append(option);
        });

        $goals.removeAttr('disabled').trigger('chosen:updated');

        // Update values for mpd
        $mpd.find('option').remove();
        $mpd.append($("<option />").val('').text(''));

        jQuery.each(response.mpd, function (name, value) {
            const option = $("<option />").val(value).text(name);

            if (mpdSelected === value) {
                option.attr('selected', true);
            }

            $mpd.append(option);
        });

        $mpd.removeAttr('disabled').trigger('chosen:updated');

        // Update values for days per mealplan
        $daysPerMealplan.find('option').remove();
        $daysPerMealplan.append($("<option />").val('').text(''));

        const mealplanDaysMin = response["mealplan-days-min"];
        const mealplanDaysMax = response["mealplan-days-max"];
        console.log("New days per mealplan min/max", mealplanDaysMin, mealplanDaysMax);
        if (mealplanDaysMin !== null &&  mealplanDaysMax !== null && mealplanDaysMin <= mealplanDaysMax) {
            for (let i = mealplanDaysMin; i <= mealplanDaysMax; i++) {
                const option = $("<option />").val(i).text(i);

                if (daysPerMealplanSelected === i) {
                    option.attr('selected', true);
                }

                $daysPerMealplan.append(option);
            }
        }
        $daysPerMealplan.removeAttr('disabled').trigger('chosen:updated');

        $vege.find('option').remove();

        if (response.vegetarian.length > 0) {
            $vege.parents('[data-container="vege"]').show();
            $vege.append($("<option />").val('').text(''));
            jQuery.each(response.vegetarian, function (name, value) {
                const option = $("<option />").val(value).text(name);

                if (vegeSelected === value) {
                    option.attr('selected', true);
                }

                $vege.append(option);
            });
            $vege.removeAttr('disabled');
        } else {
            $vege.parents('[data-container="vege"]').hide();
            $vege.attr('disabled', 'disabled');
        }

        $vege.trigger('chosen:updated');

        $preferredRecipes.find('option').remove();
        const $preferredContainer = $preferredRecipes.parents('[data-container="preferred"]');

        if (response.preferred.length > 0) {
            $preferredContainer.show();
            $preferredRecipes.append($('<option />').val('').text(''));
            response.preferred.forEach((recipe) => {
                const option = $('<option />').val(recipe.id).text(recipe.name);

                if (recipesSelected.includes(recipe.id)) {
                    option.attr('selected', true);
                }

                $preferredRecipes.append(option);
            });
            $preferredRecipes.removeAttr('disabled');
        } else {
            $preferredContainer.hide();
            $preferredRecipes.attr('disabled', 'disabled');
        }

        $preferredRecipes.trigger('chosen:updated');
    });
}

export { bindAndHandleMealCategory };
